// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__1F8Dw","title":"Privacy_title__l0PCq"};